import { getConstant } from '../utils';

export const getDiseases = getConstant('GET_DISEASES');
export const getDisease = getConstant('GET_DISEASE');

export const getDiseasesCausativeAgent = getConstant('GET_DISEASES_CAUSATIVE_AGENTS');
export const getDiseasesCulture = getConstant('GET_DISEASE_CULTURES');
export const getDiseasesDamageArea = getConstant('GET_DISEASES_DAMAGE_AREAS');
export const getDiseasesSubGroup = getConstant('GET_DISEASE_SUBGROUPS');
export const getDiseasesGroup = getConstant('GET_DISEASE_GROUPS');